/** @format */

import { action } from 'easy-peasy';
import Moment from 'moment';
import i18n from '../../i18n';

const UserModel = {
	language: 'nb',

	setLanguage: action((state, applanguage) => {
		Moment.locale(applanguage);
		i18n.changeLanguage(applanguage);
		if (applanguage === 'zhcn') applanguage = 'zh-cn';
		state.language = applanguage;
		localStorage.setItem('userLanguage', applanguage);
	}),
	refreshAppLanguage: action((state) => {
		const stored = localStorage.getItem('userLanguage');
		state.language = stored !== 'nb' && stored !== 'en' ? 'nb' : stored;
		i18n.changeLanguage(state.language);
	}),
};

export default UserModel;
